import React, { Fragment, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormView, DialogModal } from ".";
import { showDialog } from "../../appRedux/actions/common";
import { setOfferInfo } from "../../appRedux/actions/offers";

function EditInfo({ info }) {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const { dialog } = useSelector((state) => ({
    dialog: state.common.dialog,
  }));

  useEffect(() => {
    if (!dialog) setOpen(dialog);
  }, [dialog]);

  const onClick = () => {
    setOpen(true);
    dispatch(setOfferInfo(info));
    dispatch(showDialog({ title: "Edit Offer", size: "lg", id: info._id }));
  };

  return (
    <Fragment>
      <button
        className="btn btn-sm btn-outline-primary"
        style={{ padding: "4px 8px" }}
        onClick={onClick}
        title="Edit"
        key="edit_offer"
      >
        <i className="fa fa-pencil" />
      </button>
      {open && (
        <DialogModal
          infoId={info._id}
          key={info._id}
          bodyView={<FormView isUpdate={true} />}
        />
      )}
    </Fragment>
  );
}

export default EditInfo;
